import { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner";
import "./attendance.css";
import BootstrapDatepicker from "../../components/BootstrapDatepicker";
import axios from "axios";
import { API_URL } from "../../config";
import { showToast } from "../../components/toast";

const StaffAttendanceForm = () => {
  const [userName, setUserName] = useState("");
  const [userId, setUserId] = useState("");
  const [selectedMonth, setSelectedMonth] = useState(new Date());
  const [attendanceMap, setAttendanceMap] = useState({});
  const [calendarData, setCalendarData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const token = localStorage.getItem("authToken");
  const { id } = useParams();
  const [selectedDay, setSelectedDay] = useState(null); // e.g., 1, 2, 3...
  const [isPresent, setIsPresent] = useState(null); // true (present), false (absent), or null
  const [isModalOpen, setIsModalOpen] = useState(false);
  const navigate = useNavigate();

  const fetchNewAttendance = async () => {
    try {
      setLoading(true);
      const response = await axios.get(
        `${API_URL}Attendance/add/${id}?selected_date=${getMonthName(
          selectedMonth
        )}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const { userData, staffAttendanceSub } = response.data;
      setUserName(userData.user_fullname);
      setUserId(userData.id);
      // Map attendance by date (e.g., "2025-05-01" => 1)
      const newAttendanceMap = {};
      staffAttendanceSub.forEach((entry) => {
        const dateObj = new Date(entry.sdate);
        const day = dateObj.getDate();
        newAttendanceMap[day] = {
          id: entry.id, // staffattendancesub_id
          patype: entry.patype, // 1 = Present, 0 = Absent
        };
      });
      setAttendanceMap(newAttendanceMap);
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (id) {
      fetchNewAttendance();
    }
  }, [id, selectedMonth]);

  useEffect(() => {
    generateCalendar(selectedMonth);
  }, [selectedMonth]);

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const generateCalendar = (date) => {
    const year = date.getFullYear();
    const month = date.getMonth();

    const firstDay = new Date(year, month, 1);
    const startingDay = firstDay.getDay(); // 0 (Sun) to 6 (Sat)
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    const weeks = [];
    let currentDay = 1;
    let week = new Array(7).fill(null);

    // First week
    for (let i = startingDay; i < 7; i++) {
      week[i] = currentDay++;
    }
    weeks.push(week);

    // Remaining weeks
    while (currentDay <= daysInMonth) {
      week = new Array(7).fill(null);
      for (let i = 0; i < 7 && currentDay <= daysInMonth; i++) {
        week[i] = currentDay++;
      }
      weeks.push(week);
    }

    setCalendarData(weeks);
  };

  const getMonthName = (date) =>
    date.toLocaleString("default", { month: "long", year: "numeric" });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (selectedDay === null) return;
    console.log("day", selectedDay);

    const year = selectedMonth.getFullYear();
    console.log("year", year);

    const month = selectedMonth.getMonth(); // 0-indexed
    console.log("month", month);

    const selectedDate = new Date(year, month, selectedDay);
    console.log("selectedDate", selectedDate);

    const formattedDate = selectedDate.toLocaleDateString("en-CA"); // "YYYY-MM-DD"
    console.log("formatteddate", formattedDate);

    const existingPatype = attendanceMap[selectedDay];
    const attendanceId =
      existingPatype !== undefined ? existingPatype.id : null;

    const payload = {
      id: attendanceId,
      present: isPresent,
      sdate: formattedDate,
      userid: userId,
    };

    console.log(payload);

    try {
      setLoading(true);
      const response = await axios.post(
        `${API_URL}Attendance/save?id=${attendanceId}`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.success === true) {
        showToast.success(response.data.msg);
        setIsModalOpen(false);
        fetchNewAttendance();
      }
    } catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      id="page-container"
      className="page-header-fixed page-sidebar-fixed fade in"
    >
      <div id="content">
        {loading && <LoadingSpinner />}
        <div className="panel panel-default with-rounded-corner with-shadow mt-3">
          <div className="panel-heading border-0">
            <span
              className="panel-title"
              style={{ fontSize: "22px", marginBottom: "5px" }}
            >
              {userName}
            </span>
          </div>
          <div className="panel-body">
            <div className="row mt-3">
              <div className="col-md-4">
                <div className="form-group">
                  <label className="control-label">Month</label>
                  <BootstrapDatepicker
                    onChange={(date) => setSelectedMonth(date)}
                    value={selectedMonth}
                    dateFormat="MM/yyyy"
                    showMonthYearPicker
                  />
                </div>
              </div>
            </div>

            <div className="cal_box">
              <h2>{getMonthName(selectedMonth)}</h2>
              <table width="100%">
                <thead>
                  <tr>
                    {[
                      "Sunday",
                      "Monday",
                      "Tuesday",
                      "Wednesday",
                      "Thursday",
                      "Friday",
                      "Saturday",
                    ].map((day) => (
                      <th
                        key={day}
                        style={{ border: "1px solid #ccc", padding: "10px" }}
                      >
                        {day}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {calendarData.map((week, weekIdx) => (
                    <tr key={weekIdx} className="dates_tr">
                      {week.map((day, dayIdx) => (
                        <td
                          key={dayIdx}
                          className="dates_class"
                          style={{ height: "80px" }}
                          onClick={() => {
                            if (day) {
                              const record = attendanceMap[day];
                              setSelectedDay(day);
                              setIsPresent(
                                record ? record.patype === 1 : false
                              );
                              setIsModalOpen(true);
                            }
                          }}
                        >
                          {day && (
                            <>
                              {day}
                              <ul className="cal_info_ul">
                                {/* {attendanceMap[day].map((item) => {
                                  item.patype === 1 && (
                                    <li>
                                      <span className="badge badge-success">
                                        Present
                                      </span>
                                    </li>
                                  );
                                })} */}
                                <li>
                                  {attendanceMap[day]?.patype === 1 && (
                                    <span className="badge badge-success">
                                      Present
                                    </span>
                                  )}
                                  {attendanceMap[day]?.patype === 0 && (
                                    <span className="badge badge-danger">
                                      Absent
                                    </span>
                                  )}
                                </li>
                              </ul>
                            </>
                          )}
                        </td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>

        {isModalOpen && (
          <div
            className="modal-backdrop fade show"
            style={{
              backgroundColor: "rgba(0, 0, 0, 1)",
              position: "fixed",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              zIndex: 1040,
            }}
          ></div>
        )}

        {isModalOpen && (
          <div
            className="modal fade show"
            style={{ display: "block" }}
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            aria-hidden="true"
          >
            <div className="modal-dialog panel modal-sm panel-default panel-border top">
              <form
                method="post"
                id="attendance_form"
                className="form-group"
                onSubmit={handleSubmit}
              >
                <div className="modal-content">
                  <div className="modal-header justify-content-between py-0">
                    <h5 className="modal-title" style={{ fontWeight: "bold" }}>
                      Attendance
                    </h5>
                    <button
                      type="button"
                      className="btn"
                      style={{ fontSize: "25px", border: "none" }}
                      onClick={closeModal}
                    >
                      &times;
                    </button>
                  </div>
                  <div className="modal-body">
                    <div className="form-inline">
                      <label>Present</label>
                      <div className="input-group">
                        <div className="switcher">
                          <input
                            name="present"
                            id="present"
                            value="1"
                            type="checkbox"
                            checked={isPresent === true}
                            onChange={(e) => setIsPresent(e.target.checked)}
                          />
                          <label for="present"></label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button type="submit" className="btn btn-primary">
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        )}

        <Link to="#" data-click="scroll-top" className="btn-scroll-top fade">
          <i className="ti-arrow-up"></i>
        </Link>
      </div>
    </div>
  );
};

export default StaffAttendanceForm;
